/* eslint-disable yola/react/require-default-props */
import React, { forwardRef } from 'react';
import BaseSelect from '../base-select';
import { APPEARANCES, SIZES } from '../base-select/constants';
import noop from '../../../utils/noop';

const defaultComponents = {};

const SimpleSelect = forwardRef(
  (
    {
      size = SIZES.small,
      id = undefined,
      name = undefined,
      placeholder = '',
      options,
      value = undefined,
      defaultValue = undefined,
      disabled = false,
      invalid = false,
      preventOverflow = false,
      noVerticalSpacing = false,
      noHorizontalSpacing = false,
      noSpacingBetweenElements = false,
      onChange = noop,
      onBlur = noop,
      onFocus = noop,
      maxMenuHeight = undefined,
      components = defaultComponents,
      transparent = false,
      menuWidth = '',
      menuAlignment = 'left',
      menuPlacement = 'auto',
      className = '',
      openMenuOnFocus = false,
    },
    ref
  ) => (
    <BaseSelect
      ref={ref}
      appearance={APPEARANCES.default}
      size={size}
      id={id}
      name={name}
      placeholder={placeholder}
      options={options}
      value={value}
      defaultValue={defaultValue}
      clearable={false}
      disabled={disabled}
      invalid={invalid}
      preventOverflow={preventOverflow}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      components={components}
      maxMenuHeight={maxMenuHeight}
      transparent={transparent}
      menuWidth={menuWidth}
      menuAlignment={menuAlignment}
      menuPlacement={menuPlacement}
      noVerticalSpacing={noVerticalSpacing}
      noHorizontalSpacing={noHorizontalSpacing}
      noSpacingBetweenElements={noSpacingBetweenElements}
      className={className}
      openMenuOnFocus={openMenuOnFocus}
    />
  )
);

SimpleSelect.displayName = 'SimpleSelect';

export default SimpleSelect;
